import { render, staticRenderFns } from "./PurchaseCard.vue?vue&type=template&id=611dd5ae&scoped=true"
import script from "./PurchaseCard.vue?vue&type=script&lang=js"
export * from "./PurchaseCard.vue?vue&type=script&lang=js"
import style0 from "./PurchaseCard.vue?vue&type=style&index=0&id=611dd5ae&prod&lang=scss&scoped=true"
import style1 from "./PurchaseCard.vue?vue&type=style&index=1&id=611dd5ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611dd5ae",
  null
  
)

export default component.exports